var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Gauge"},[_c('div',[_c('canvas',{staticStyle:{"width":"80px","height":"70px"},attrs:{"id":this.id}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }